import {
  FETCH_ALL_QUICK_TAPS,
  FETCH_ALL_QUICK_TAPS_START,
  FETCH_TAGS,
  FETCH_QUICK_TAPS_PAGE_START,
  FETCH_QUICK_TAPS_PAGE_SUCCESS,
  FETCH_QUICK_TAPS_PAGE_FAILURE,
} from "../constants/ActionTypes";

const INITIAL_STATE = {
  // Legacy state (full collection, no pagination). Still used by v1 + the
  // existing /quick-taps/featured manager. Untouched.
  isLoading: false,
  all_quick_tap_sessions: null,
  current_tags: null,

  // Paginated state — populated by `fetchQuickTapsPage`. Mirrors the
  // sessions.paginated slice shape so the table component is structurally
  // the same.
  paginated: {
    data: [],
    page: 1,
    per_page: 50,
    page_count: 0,
    has_more: false,
    total_count: 0,
  },
  paginatedLoading: false,
  paginatedError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_ALL_QUICK_TAPS_START:
      return { ...state, isLoading: true };
    case FETCH_ALL_QUICK_TAPS:
      return { ...state, all_quick_tap_sessions: action.payload, isLoading: false };
    case FETCH_TAGS:
      return { ...state, current_tags: action.payload };

    case FETCH_QUICK_TAPS_PAGE_START:
      return { ...state, paginatedLoading: true, paginatedError: null };
    case FETCH_QUICK_TAPS_PAGE_SUCCESS:
      return {
        ...state,
        paginatedLoading: false,
        paginated: {
          data:        action.payload.data        ?? [],
          page:        action.payload.page        ?? 1,
          per_page:    action.payload.per_page    ?? 50,
          page_count:  action.payload.page_count  ?? 0,
          has_more:    !!action.payload.has_more,
          total_count: action.payload.total_count ?? 0,
        },
      };
    case FETCH_QUICK_TAPS_PAGE_FAILURE:
      return { ...state, paginatedLoading: false, paginatedError: action.payload };

    default:
      return state;
  }
}
